import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LeftPanel from '../LeftPanel/LeftPanel';
import RightPanel from '../RightPanel/RightPanel';
import './dashboard.css';
import LineChartTrends from '../lineChart/chart';
import TrendCharts from '../trendCharts/trendCharts';
import ReportSection from '../Report/Report';
import ImageUpload from '../imageUpload/imageUpload';

const Dashboard = () => {
  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Helper: map latitude to region (simple approximation)
  const getRegion = (lat) => {
    if (lat > 30 && lat <= 60) return 'North America';
    if (lat >= -35 && lat <= 35) return 'Africa';
    if (lat > 5 && lat <= 55) return 'Asia';
    if (lat < -15 && lat >= -55) return 'South America';
    if (lat > 35 && lat <= 70) return 'Europe';
    return 'Other';
  };

  useEffect(() => {
    const fetchCrisisData = async () => {
      try {
        const res = await axios.get('https://node-api-dot-crisisvision-ai-backend.uc.r.appspot.com/api/crises');
        const data = res.data;

        // Bar Chart: Group by region
        const regionMap = {};
        data.forEach((c) => {
          const region = getRegion(c.location.lat);
          regionMap[region] = (regionMap[region] || 0) + 1;
        });
        const bar = Object.entries(regionMap).map(([region, cases]) => ({
          region,
          cases,
        }));
        setBarData(bar);

        // Pie Chart: Simulate extra crisis types
        const pie = [
          { type: 'Wildfire', value: data.length },
          { type: 'Flood', value: Math.floor(data.length * 0.25) },
          { type: 'Pollution', value: Math.floor(data.length * 0.2) },
          { type: 'Disease', value: Math.floor(data.length * 0.35) },
        ];
        setPieData(pie);

        setLoading(false);
      } catch (error) {
        console.error('Failed to load dashboard data:', error);
        setLoading(false);
      }
    };

    fetchCrisisData();
  }, []);

  return (
    <div className="dashboard-container">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <LeftPanel />
          </div>
          <div className="col-md-9">
            <RightPanel />
          </div>
        </div>

        <div className="row" style={{ marginTop: '2rem' }}>
          <div className="col-md-6">
            <LineChartTrends />
          </div>
          <div className="col-md-6">
            <ImageUpload />
          </div>
        </div>

        <div style={{ marginTop: '2rem' }}>
          <TrendCharts  />
        </div>

        <div style={{ marginTop: '2rem' }}>
          {!loading && <ReportSection barData={barData} pieData={pieData} />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
